export default "__VITE_ASSET__bsIFxO6E__"